import { Spinner } from "react-bootstrap";

export default function Loading({ isToHidden }) {

    return (
        <div hidden={isToHidden} className="loading-overlay"
            style={{
                position: "absolute",
                inset: 0, // cobre todo o card
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "rgba(255, 255, 255, 0.6)",
                backdropFilter: "blur(2px)",
                borderRadius: "1rem",
                zIndex: 1000,
            }}
        >
            <Spinner animation="border" role="status" />
        </div>
    );
}